import styled from "styled-components";
import { breakpoints } from "../../constants/media";

const Container = styled.div`
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  background-color: var(--blanco);
  overflow: hidden;

  // Header
  .landing-header {
    width: 100%;
    padding: 20px 24px;
    display: flex;
    justify-content: center;
    box-sizing: border-box;
    border-bottom: 1px solid var(--grisClaro);
  }

  .landing-header-contenido {
    width: 100%;
    max-width: 1270px;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .logo-segurobici {
    height: 32px;
  }

  .landing-header-contacto {
    display: flex;
    align-items: center;
    gap: 16px;
  }

  .landing-header-contacto a {
    color: var(--naranja100);
    font-size: 14px;
    font-weight: 500;
    text-decoration: none;
    display: flex;
    align-items: center;
    transition: 0.2s all;
  }

  .landing-header-contacto a:first-child {
    color: var(--negro);
  }

  .landing-header-contacto a:hover {
    color: var(--naranja40);
  }

  // Hero
  .hero {
    width: 100%;
    padding: 56px 16px 24px 16px;
    display: flex;
    flex-direction: column;
    align-items: center;
    box-sizing: border-box;
  }

  .hero-titulo {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 24px;
  }

  .logo-alianza {
    width: 170px;
    height: auto;
  }

  .hero-titulo h1 {
    margin: 0;
    color: var(--negro);
    letter-spacing: -0.015em;
  }

  // Tarjeta del formulario
  .tarjeta {
    width: 100%;
    max-width: 440px;
    margin: 40px 0 0 0;
    padding: 32px;
    box-sizing: border-box;
    background-color: var(--blanco);
    border: 1px solid var(--grisClaro);
    border-radius: 12px;
    box-shadow: 0px 10px 60px rgba(255, 151, 0, 0.22);
  }

  form {
    display: flex;
    flex-direction: column;
  }

  input[type="text"],
  input[type="tel"] {
    width: 100%;
    margin: 0 0 16px 0;
    padding: 11px;
    box-sizing: border-box;
    font-family: "DM Sans", sans-serif;
    font-size: 14px;
    color: var(--negro);
    border: 1.7px solid var(--grisClaro);
    border-radius: 8px;
    background-color: var(--blanco);
    -webkit-appearance: none;
    appearance: none;
    transition: 0.2s all;
  }

  input[type="text"]:focus,
  input[type="tel"]:focus {
    border-color: var(--naranja100);
    outline: none;
  }

  input[name="nombre"]:not(:placeholder-shown) {
    text-transform: capitalize;
  }

  .fila-telefono {
    display: flex;
    gap: 12px;
  }

  .fila-telefono input {
    flex: 1 1 0;
    min-width: 0;
  }

  .fila-telefono input[name="codigoArea"] {
    flex: 0 0 34%;
  }

  .input-error {
    border-color: var(--rojoError) !important;
  }

  .mensaje-error {
    margin: -8px 0 16px 0;
    font-size: 12px;
    line-height: 1.5;
    color: var(--rojoError);
  }

  .mensaje-envio {
    margin: 16px 0 0 0;
    text-align: center;
  }

  .campo-oculto {
    position: absolute !important;
    left: -9999px !important;
    width: 1px !important;
    height: 1px !important;
    opacity: 0;
  }

  // Valor de la bici
  .valor-bici {
    margin: 8px 0 0 0;
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    align-items: baseline;
    font-family: "DM Sans", sans-serif;
  }

  .valor-bici label {
    font-size: 13px;
    font-weight: 500;
    color: var(--negro);
  }

  .valor-bici-actual {
    font-size: 14px;
    font-weight: 700;
    color: var(--naranja100);
  }

  .valor-bici-limite {
    margin: 4px 0 0 0;
    font-size: 12px;
    color: var(--gris);
  }

  .valor-bici input[type="range"] {
    width: 100%;
    margin: 14px 0 0 0;
    padding: 0;
    background: transparent;
    -webkit-appearance: none;
    appearance: none;
    cursor: pointer;
  }

  .valor-bici input[type="range"]:focus {
    outline: none;
  }

  .valor-bici input[type="range"]::-webkit-slider-runnable-track {
    height: 8px;
    border-radius: 25px;
    background: linear-gradient(
      to right,
      var(--naranja100) var(--relleno),
      var(--grisClaro) var(--relleno)
    );
  }

  .valor-bici input[type="range"]::-moz-range-track {
    height: 8px;
    border-radius: 25px;
    background: var(--grisClaro);
  }

  .valor-bici input[type="range"]::-moz-range-progress {
    height: 8px;
    border-radius: 25px;
    background: var(--naranja100);
  }

  .valor-bici input[type="range"]::-webkit-slider-thumb {
    width: 18px;
    height: 18px;
    margin-top: -5px;
    background-color: var(--blanco);
    border: 2.5px solid var(--naranja100);
    border-radius: 50%;
    -webkit-appearance: none;
  }

  .valor-bici input[type="range"]::-moz-range-thumb {
    width: 14px;
    height: 14px;
    background-color: var(--blanco);
    border: 2.5px solid var(--naranja100);
    border-radius: 50%;
  }

  .valor-bici input[type="range"]:focus-visible::-webkit-slider-thumb {
    box-shadow: 0 0 0 4px rgba(255, 151, 0, 0.25);
  }

  // Botón
  button[type="submit"] {
    margin: 32px auto 0 auto;
    padding: 10px 28px;
    display: flex;
    align-items: center;
    gap: 10px;
    font-family: "Poppins", sans-serif;
    font-size: 15px;
    font-weight: 600;
    color: var(--blanco);
    background-color: var(--naranja100);
    border: 0;
    border-radius: 8px;
    cursor: pointer;
    transition: 0.2s all;
  }

  button[type="submit"] img {
    height: 17px;
    transition: 0.4s all;
  }

  button[type="submit"]:hover:not(:disabled) {
    background-color: var(--naranja40);
  }

  button[type="submit"]:hover:not(:disabled) img {
    transform: translate(6px);
  }

  button[type="submit"]:disabled {
    opacity: 0.7;
    cursor: wait;
  }

  // Confirmación
  .confirmacion {
    padding: 8px 0;
    display: flex;
    flex-direction: column;
    align-items: center;
    text-align: center;
  }

  .confirmacion img {
    width: 56px;
    margin: 0 0 20px 0;
  }

  .confirmacion-mensaje {
    margin: 0 0 16px 0;
    font-size: 16px;
    line-height: 1.6;
    color: var(--negro);
  }

  .confirmacion-gracias {
    margin: 0;
    font-family: "Poppins", sans-serif;
    font-size: 17px;
    font-weight: 600;
    color: var(--naranja100);
  }

  @media (max-width: ${breakpoints.tablet768}) {
    .hero {
      padding-top: 32px;
    }

    .hero-titulo {
      flex-direction: column;
      gap: 16px;
      text-align: center;
    }

    .logo-alianza {
      width: 150px;
    }

    .tarjeta {
      margin-top: 28px;
      padding: 24px 20px;
    }

    // 16px evita el zoom automático de iOS al enfocar el input
    input[type="text"],
    input[type="tel"] {
      font-size: 16px;
    }

    .fila-telefono input[name="codigoArea"] {
      flex-basis: 38%;
    }
  }

  @media (max-width: ${breakpoints.mobile450}) {
    .landing-header {
      padding: 16px;
    }

    .logo-segurobici {
      height: 26px;
    }

    .landing-header-contacto {
      gap: 12px;
    }

    .landing-header-contacto a:first-child {
      font-size: 13px;
    }
  }
`;

export default Container;
